import { forwardRef } from 'react';

import StringInput from './StringInput';

/**
 * @author Burak Unsal
 * @description The Textarea component, you can use it to create a textarea.
 * @param {Object} props - props of the typography component
 * @param {string} [props.name] - Naming so that the input can be called.
 * @param {boolean} [props.disabled] -  Disables onclick event and UI true/false.
 * @param {string} [props.placeholder] - What should appear in the input's placeholder.
 * @param {string} [props.errorMessage] - The text that should appear in case of Error.
 * @param {string} [props.rows = 3] - The number of rows that should be displayed in the input. Default value is 3.
 * @param {string} [props.value] - The value that should be displayed in the input.
 * @returns {JSX} TextArea component.
 */

const TextArea = (props, ref) => <StringInput ref={ref} component="textarea" rows="3" maxlength="254" {...props} />;

export default forwardRef(TextArea);
